
  // This file was autogenerated by dynamically running set-env.script.ts and using dotenv for managing API key secrecy
  export const environment = {
    production: false,
    baseUrl: "https://bravesnoutsdev.firebaseapp.com",
    firebaseConfig: {
      apiKey: "AIzaSyD_RBrk9hkYGbylHCgBybLWdq8avksqyP8",
      authDomain: "bravesnoutsdev.firebaseapp.com",
      databaseURL: "undefined",
      projectId: "bravesnoutsdev",
      storageBucket: "bravesnoutsdev.appspot.com",
      messagingSenderId: "735669987946",
      appId: "1:735669987946:web:5510e40fd4650b4fcdf813",
      measurementId: "G-ENWG0KM0WY",
      appCheckKey: "6LfKsEMrAAAAAKbDyn3Ps5aUmbskAlR5GJBAMsC0"
    },
    pageSizes: {
      itemsList: 16,
    },
    itemCardConfig: {
      minBidOffset: 5,
      maxBidOffset: 30,
      bidStepSize: 5
    },
    imageCacheSeed: 6,
    stripe: {
       publishableKey: 'obsolete'
    },
  };
